import React, { Component } from "react";
import socketIOClient from "socket.io-client";
import { httpUploadFile, URLS } from "./../network";
import download from "downloadjs"
import { isNullOrEmpty, SCRAPING_PAGE_TYPE, toObject } from "./../utils";

import './../css/bienes.css';

class Bienes extends Component {

    constructor() {
        super();
      
        this.state = {
            filePath: "",
            fileName: "",
            rows: [],
            showLoader: false,
            currentRevision: "",
            selectedRegion: ""
        }
    }

    componentDidMount() {
        this.fileSelector = this.buildFileSelector();
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
    
    buildFileSelector = () => {
		
        const fileSelector = document.createElement("input");
        fileSelector.setAttribute("type", "file");
        fileSelector.setAttribute("multiple", "multiple");
    
        fileSelector.onchange = this.parseFile();
        return fileSelector;
    };

    parseFile = () => (e) => {

        const file = e.target.files[0];   
        httpUploadFile(URLS.UPLOAD_FILE, { newFile: file})
            .then ( (data) => {
                
                this.setState({filePath: data.path, fileName: data.realname });
            })
            .catch ((err) => {
                console.log ("err: ", err);
            });
    };
        
    onFileClickSelect = () => (e) => {
        e.preventDefault();
        this.fileSelector.click();
    };

    onSearchClick = () => {
        
        if ( isNullOrEmpty( this.state.fileName)) {
            alert("Debes cargar primero un archivo!");
            return;
        }

        const socket = socketIOClient(URLS.MAIN_URL, {  query: "type="+ SCRAPING_PAGE_TYPE.Bienes});
        socket.on("connection", (data) => {
            console.log (data);
        });

        socket.on("on_row_incoming", (data) => {
            const payload = toObject(data);
            if (!payload || !payload.tender) {
                return;
            }

            let currentrows = this.state.rows;
            currentrows.push(payload.tender);

            const lastRow = currentrows[currentrows.length - 1];
            const revision = (lastRow.type === 1) ? "Actuales" : (lastRow.type === 2) ? "Futuras" : "Finalizadas";
            this.setState({
                rows: currentrows,
                currentRow: payload.row,
                currentRevision: revision
            });
        });

        socket.on ("on_process_end", (filename) => {
            socket.emit("disconnect");
            socket.disconnect();

            this.setState({showLoader: false, fileName: ""});
            fetch(URLS.DOWNLOAD_FILE + "?file="+filename)
                .then ((res) => {
                    return res.blob();
                })
                .then ( (blob) => {
                    download(blob, "bienes_nacionales.xls", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                })
                .catch( (err) => {
                    console.log (err);
                })
        });

        socket.on("on_rows_to_proccess", (rowsNumber) => {
            this.setState({maxRows: rowsNumber});
        })

        socket.on("on_error", (err) => {
            this.setState({showLoader: false});
            //console.log ("err: " , err);
            this.props.errorMessage(err.message);
            socket.emit("disconnect");
            socket.disconnect();
        });

        socket.on("on_current_processing", (data) => {
            this.setState({currentRevision: data});
        });
        
        this.setState({rows: [], showLoader: true});
        socket.emit("process_start", { filePath: this.state.filePath, region: this.state.selectedRegion});
    }

    selectChange = (event) => {
        const selection = event.target.value;
        this.setState({selectedRegion: selection});
    }

    render () {
        return (
            <div className="bienes-container">
                <h3>Revision del estado de bienes en sitio Bienes nacionales </h3>
                <p>
                    La busqueda y revision del estado de los bienes es por nombre y el estado actual. En el archivo que se suba debe venir el nombre y el tipo(estado) actual.<br />
                    Se deja para descargar un archivo de ejemplo.
                    <a href={URLS.MAIN_URL + "assets/bienes_ejemplo.xlsx"}>
                        <span className="fas fa-file-excel pjud-excel-icon" title="Documento de ejemplo"></span>
                    </a>
                </p>
                <fieldset className="scheduler-border" >
                    <legend className="scheduler-border">Selecciona el archivo con Bienes a revisar</legend>
                    <div className="filter-doc-file">
                        <input type="text" id="filterIdsTxt" className="form-control"
                            placeholder="Selecciona archivo" value={this.state.fileName}/>
                        <button className="btn btn-outline-primary" onClick={this.onFileClickSelect()}> Abrir</button>
                    </div>
                </fieldset>
                
                <div className="bienes-filter-container">
                    Filtro 
                    <select type="text" className="search-field" name="region" placeholder="Search" value={this.state.selectedRegion} onChange={this.selectChange}>
                        <option value="">Todas las Regiones</option>
                        <option value="arica-y-parinacota" >Arica y Parinacota</option>
                        <option value="tarapaca" >Tarapacá</option>
                        <option value="antofagasta" >Antofagasta</option>
                        <option value="atacama" >Atacama</option>
                        <option value="coquimbo" >Coquimbo</option>
                        <option value="araucania" >Araucanía</option>
                        <option value="los-lagos" >Los Lagos</option>
                    </select>
                    <button className="btn btn-outline-primary" onClick={this.onSearchClick}>Buscar</button>
                    { this.state.showLoader && <div style={{marginLeft: "10px"}}><div id="loader" className="loader-seia loader-bienes"></div>{this.state.currentRevision}</div>  }
                </div>

                <div id="tableContainer" className="result-table">
                    <table className="table table-striped table-fixed">
                        <thead>
                            <tr>
                                <th scope="col">Nombre</th>
                                <th scope="col">Estado</th>
                                <th scope="col">Nuevo Estado</th>
                                <th scope="col">Categoría</th>
                                <th scope="col">Descripcción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.rows.map( (row, index) => {
                                    
                                    return (
                                        <tr key={index}>
                                            <td className="first-table-row">{row.name}</td>
                                            <td>{row.status}</td>
                                            <td>{row.newStatus}</td>
                                            <td>{(row.type === 1) ? "Actuales" : (row.type === 2) ? "Futuras" : "Finalizadas" }</td>
                                            <td>{row.attributes["descripcion"]}</td>
                                        </tr>
                                    );
                                })   
                            }
                        
                        </tbody>
                    </table>
                    <div style={{ float:"left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>
                </div>
            </div>
        );
    }
    
}

export default Bienes;